requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
        Alpine.store('xBadges', {

            fixedPositionTemplate: `<div
                class="x-badge-{label-id} x-badge-container pointer-events-none{container-img-class} ltr"
                {preview-show-condition}
            >
                {content}
            </div>`,
            customPositionTemplate: `<div
                class="x-badge-{label-id} x-badge-container min-w-fit max-w-full max-h-full pointer-events-none{container-css-class} ltr"
                x-data="{
                contentHeight: 1,
                rePosition() {
                    this.$nextTick(() => {
                    this.contentHeight = this.$refs.content ? this.$refs.content.offsetHeight : contentHeight;
                    });
                }
                }"
                x-intersect.once="rePosition();
                if (Shopify.designMode) {
                    window.addEventListener('resize', () => {
                    if ($store.xBadges.lastWindowWidth != window.innerWidth) {
                        rePosition();
                    }
                    });
                } else {
                    installMediaQueryWatcher('(min-width: 768px)', (matches) => rePosition());
                }"
                {preview-show-condition}
                :style="'{css-position} min-height: ' + contentHeight + 'px'"
            >
                {content}
            </div>`,
            productDetailTemplate: `<div
                class="x-badge-{label-id} x-badge-container min-w-fit max-w-full max-h-full bottom-0 pointer-events-none{container-css-class}{container-img-class}"
            >
                {content}
            </div>`,
            outSideImageTemplate: `<div class="hidden"
                x-data="{
                setPosition() {
                    const element = $el.closest('.card-product').getElementsByClassName('{queryEL}');
                    for (let i = 0; i < element.length; i++) {
                    element[i].innerHTML += $el.innerHTML;
                    }
                }
                }"
                x-init="setPosition()">
                <div
                class="x-badge-{label-id} x-badge-container min-w-fit max-w-full max-h-full bottom-0 pointer-events-none{container-img-class}"
                >
                {content}
                </div>
            </div>`,
            previewActiveBlock: window.xBadgesPreviewActiveBlock,

            init() {
                if (Shopify.designMode) {
                document.addEventListener('shopify:block:select', (event) => {
                    if (!event.target.classList.contains('x-badges-block-preview')) return;

                    let blockData = xParseJSON(event.target.getAttribute('data-shopify-editor-block'));
                    this.previewActiveBlock = blockData.id;
                    window.xBadgesPreviewActiveBlock = blockData.id;

                    document.dispatchEvent(new CustomEvent("eurus:badges:block-select"));
                });
                }
            },

                load ( element , callback = () => {} , container = null ){

                    const load = () => this.doLoad(element,callback)

                    if( container )
                        element.container = container

                    const slider = element
                        .closest(`[ x-data-slider ]`)

                    if( ! slider ){
                        load()
                        return
                    }

                    const isInitialized = slider.classList
                        .contains('is-initialized')

                    if( isInitialized ){
                        load()
                        return
                    }

                    const sectionId = element
                        .closest(`[ x-data-slider ]`)
                        .getAttribute('x-data-slider')

                    const event = `eurus:${ sectionId }:splide-ready`

                    document.addEventListener(event,load)
                },


                doLoad ( element , callback = () => {} ){

                    this.initAllLabels(element)

                    if( Shopify.designMode ){

                        const json = element
                            .getAttribute('x-labels-data')

                        const data = xParseJSON(json)

                        if( ! data )
                            return

                        if( data.isXBadgesPreview )
                            return

                        document.addEventListener('shopify:section:load',
                            () => this.initAllLabels(element))
                    }

                    callback(element)
                },

                initAllLabels ( element ){

                    const json = element
                        .getAttribute('x-labels-data')

                    let data = xParseJSON(json)

                    if( ! data )
                        return

                    if( Shopify.designMode ){

                        element
                        .querySelectorAll(`.x-badge-container`)
                        .forEach(( label ) => label.remove() )
                    }

                    document
                    .querySelectorAll(`.x-badges-block-data`)
                    .forEach(( block ) => {

                        const json = block.getAttribute
                            ('x-badges-block-data')

                        const label = xParseJSON(json)

                        if( ! label.enable && ! data.isXBadgesPreview )
                            return;

                        const icon = block.getAttribute
                            ('x-badges-icon')

                        label.settings.icon = icon

                        // console.debug('INitAll',element,label,data)

                        this.appendLabel(element,label,data)
                    })

                    element.removeAttribute('x-labels-data')
                },


            appendLabel(el, label, productData) {
                if (productData.container == 'product-info' || label.settings.position == 'custom') {
                el.innerHTML += this.processTemplate(el, label, productData);
                return;
                }

                let container = el.querySelector(`.${label.settings.position}-container`);
                if (!container) {
                container = this.createFixedPositionContainer(label.settings.position);
                el.appendChild(container);
                }

                container.innerHTML += this.processTemplate(el, label, productData);
            },
            createFixedPositionContainer(position) {
                let HTMLClass = `${position}-container label-container absolute gap-1 space-y-1`;
                HTMLClass += position.includes('top') ? ' top-1 flex-col' : ' bottom-1 flex-col-reverse';
                HTMLClass += position.includes('left') ? ' left-1' : ' right-1';

                const container = document.createElement("div");
                container.setAttribute('class', HTMLClass);

                return container;
            },
            processContent(el, label, productData) {
                let content = false;
                const canShow = this.canShow(label, productData);

                if (label.settings.image && canShow) {
                /** image label */
                let imageHeight, imageWidth;
                if (productData.container == 'product-info') {
                    imageHeight = 126;
                    imageWidth = Math.round(imageHeight * label.settings.image_aspect_ratio);
                } else {
                    imageWidth = label.settings.size * 15;
                    imageHeight = imageWidth / label.settings.image_aspect_ratio;
                }
                let image;
                if (label.settings.image.src) {
                    image = label.settings.image.src.includes('burst.shopifycdn.com') ? label.settings.image.src :
                    label.settings.image.src + `&width=` + (imageWidth * 3);
                } else {
                    image = label.settings.image.includes('burst.shopifycdn.com') ? label.settings.image :
                    label.settings.image + `&width=` + (imageWidth * 3);
                }
                if (productData.container == "card") {
                    var imageDirection = label.settings.horizontal_position > 50 ? "justify-end" : "justify-start";
                    var styleImage = 'width: var(--width-image-label); height: var(--height-image-label)';
                } else {
                    var imageDirection = productData.make_content_center ? "justify-center" : "justify-start";
                    var styleImage = '';
                }
                content = `<div x-ref="content" class='x-badge-content flex ${imageDirection}{css-opacity}'>
                    <img
                    loading="lazy"
                    width="` + imageWidth + `"
                    height="` + imageHeight + `"
                    alt="` + (label.settings.image_alt.length > 0 ? label.settings.image_alt : productData.title) + `"
                    src="` + image + `"
                    style="${styleImage}"
                    />
                </div>`;
                } else if (label.settings.content && canShow) {
                /** text label */
                let qty = (productData.inventory_management.length < 1 || productData.qty < 0) ? '' : productData.qty
                let saleAmount = productData.sale_amount.includes('-') ? '' : productData.sale_amount;
                let countDown = label.settings.schedule_enabled ? '<span x-intersect.once="$nextTick(() => { if (typeof rePosition !== `undefined`) {rePosition()} });" class="x-badge-countdown-' + label.id + ' label-countdown empty:hidden"></span>' : '';
                let sale = Math.round((productData.compare_at_price - productData.price) * 100 / productData.compare_at_price);
                sale = sale == 100 ? 99 : sale;
                sale = sale > 0 ? sale + '%' : '';

                content = label.settings.content.replace(/{sale}/gi, sale)
                            .replace(/{sale_amount}/gi, saleAmount)
                            .replace(/{qty}/gi, qty)
                            .replace(/{price}/gi, productData.price_with_currency)
                            .replace(/{count_down}/gi, countDown);

                if (productData.metafield_label) {
                    Object.entries(productData.metafield_label).forEach(([key, value]) => {
                    content = content.replace(`{${key}}`, value);
                    });
                }
                const padding = label.settings.size / 2;
                const padding_mobile = label.settings.size_mobile / 2;
                const sizeClass = productData.container == 'product-info' ? '' : ` pt-${padding_mobile} pb-${padding_mobile} pl-${padding_mobile + 1.5} pr-${padding_mobile + 1.5} md:pt-${padding} md:pb-${padding} md:pl-${padding + 1.5} md:pr-${padding + 1.5}`;
                const inlineStyle = productData.container == 'product-info' ? '' : `style="font-size: var(--font-size-scale);"`;
                const inlineStyleIcon = productData.container == 'product-info' ? '' : `style="height: var(--font-size-scale); width: var(--font-size-scale); min-width: var(--font-size-scale);"`;
                content = content.length > 0
                    ? `<div
                        x-ref="content"
                        class='x-badge-content ltr x-badge-text select-none inline-flex justify-center${sizeClass} items-center{css-opacity}{css-type} gap-2'
                        ${inlineStyle}
                    ><span class="icon-label empty:hidden" ${inlineStyleIcon}>${label.settings.icon}</span><span class="leading-normal w-fit p-break-words">${content}</span></div>` : false;

                if (countDown.length > 0 && label.settings.schedule_enabled) {
                    Alpine.store('xHelper').countdown(label.settings, function(canShow, seconds, minutes, hours, days) {
                    let container = el.container ? el.container : el;
                    const countdownElements = container.getElementsByClassName('x-badge-countdown-' + label.id);

                    if (!canShow) {
                        for (let i = 0;i < countdownElements.length;i++) {
                        countdownElements[i].innerHTML = '';
                        }

                        return;
                    }

                    days = days > 0 ? days + "D&nbsp;&nbsp;&nbsp;" : "";
                    hours = hours == 0 && days.length == 0 ? "" : hours + " : ";
                    const timeLeft = days + hours + minutes + " : " + seconds;

                    for (let i = 0;i < countdownElements.length;i++) {
                        countdownElements[i].innerHTML = timeLeft;
                    }
                    });
                }
                }

                return content;
            },
            processTemplate(el, label, productData) {
                let template = '';
                let content
                if (content = this.processContent(el, label, productData)) {
                const cssOpacity = " opacity-" + label.settings.opacity;
                const cssPosition = productData.container == "card" ? "left: " + label.settings.horizontal_position + "%;" + " transform: translate(-"+ label.settings.horizontal_position+"%, -"+ label.settings.vertical_position+"%);"
                                    + " top: " + (label.settings.vertical_position) + "%;"
                                    : "";
                let cssType = '';
                if (label.settings.type == 'round') cssType = ' rounded-md';
                if (label.settings.type == 'rounded-full') cssType = ' rounded-full';

                let containerCssClass = productData.container == "card" ? " absolute w-max" : "";
                containerCssClass += label.settings.horizontal_position > 50 ? " text-end" : " text-start";
                const previewShowCondition = productData.isXBadgesPreview ? `x-show="$store.xBadges.previewActiveBlock == '{label-id}'"` : '';
                const imgClass = label.settings.image ? ' label-img' : '';

                template = this.getLableTemplate(productData.container, label.settings.position);
                template = template.replace('{preview-show-condition}', previewShowCondition)
                    .replace('{content}', content)
                    .replace('{css-opacity}', cssOpacity)
                    .replace('{css-position}', cssPosition)
                    .replace('{css-type}', cssType)
                    .replace('{container-css-class}', containerCssClass)
                    .replace('{container-img-class}', imgClass)
                    .replace(/{label-id}/gi, label.id);
                }

                const isBonus = (
                    label.type == 'Bonus' &&
                    productData.Has_Bonus
                )

                if( isBonus )
                    template = `
                        <bonus-label
                            data-variant = '${ productData.Variant }'
                            data-handle = '${ productData.Handle }'
                            class = 'Bonus-Label-Component'
                        > ${ template } </bonus-label>
                    `

                return template;
            },
            getLableTemplate(container, position) {
                if (container == 'product-info') {
                return this.productDetailTemplate;
                } else if (position == 'custom') {
                return this.customPositionTemplate;
                } else if (position == 'below-image' || position == 'bottom-card' || position == 'next-price') {
                return this.outSideImageTemplate.replace('{queryEL}', position);
                }

                return this.fixedPositionTemplate;
            },
            canShow(label, productData) {

                if( productData.isXBadgesPreview )
                    return true

                if(
                    productData.container == 'card' &&
                    ! label.settings.show_on_product_card
                )   return false

                if(
                    productData.container == 'product-info' &&
                    ! label.settings.show_on_product_page
                )   return false

                if(
                    label.type == 'sale-label' &&
                    productData.compare_at_price > productData.price
                )   return true

                if(
                    label.type == 'sold-out-label' &&
                    ! productData.available
                )   return true

                if( label.type === 'Special' )
                    return productData.Has_Sale

                if( label.type == 'Bonus' )
                    return productData.Has_Bonus

                if( label.type == 'preorder-label' )
                    return productData.can_show_preorder

                if(
                    label.type == 'text-label' &&
                    label.settings.content.toLowerCase() == 'neu'
                ) return productData.Is_New === true

                if (label.settings.schedule_enabled) {
                let endDate = new Date(
                    label.settings.end_year,
                    label.settings.end_month - 1,
                    label.settings.end_day,
                    label.settings.end_hour,
                    label.settings.end_minute
                );
                label.endTime = endDate.getTime()
                    + (-1 * label.settings.timezone * 60 - endDate.getTimezoneOffset()) * 60 * 1000;

                let startDate = new Date(
                    label.settings.start_year,
                    label.settings.start_month - 1,
                    label.settings.start_day,
                    label.settings.start_hour,
                    label.settings.start_minute
                );
                label.startTime = startDate.getTime()
                    + (-1 * label.settings.timezone * 60 - startDate.getTimezoneOffset()) * 60 * 1000;

                let now = new Date().getTime();
                if (label.endTime < now) {
                    return false;
                }

                if (label.startTime > now) {
                    return false;
                }
                }

                if( label.settings.applied_products.includes(productData.id) )
                    return true

                for ( let i=0;i<label.settings.applied_collections.length;i++ )
                    if( productData.collections.includes(label.settings.applied_collections[i]) )
                        return true

                if(
                    label.type != 'sold-out-label' &&
                    label.type != 'sale-label' &&
                    label.settings.applied_products.length == 0 &&
                    label.settings.applied_collections.length == 0
                )   return true;

                return false;
            }
        });
    });
});
